import api, { riderApi } from "./api";

// ─── User ─────────────────────────────────────────────────────────────────────

export const createTravelApi = async (payload) => {
  const { data } = await api.post("/api/v1/travels", payload);
  return data;
};

export const payTravelBySlipApi = async (travelId, formData) => {
  const { data } = await api.post(`/api/v1/travels/${travelId}/pay`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const payTravelByWalletApi = async (travelId) => {
  const { data } = await api.post(`/api/v1/travels/${travelId}/pay-wallet`);
  return data;
};

/** เงินสดกับคนขับ — เข้า seeking_rider โดยไม่ hold Wallet */
export const startTravelSeekingCashApi = async (travelId) => {
  const { data } = await api.post(`/api/v1/travels/${travelId}/seek-cash`);
  return data;
};

export const cancelTravelApi = async (travelId, reason) => {
  const { data } = await api.post(`/api/v1/travels/${travelId}/cancel`, { reason });
  return data;
};

export const getMyTravelsApi = async () => {
  const { data } = await api.get("/api/v1/travels/my");
  return data;
};

export const getTravelByIdApi = async (travelId) => {
  const { data } = await api.get(`/api/v1/travels/${travelId}`);
  return data;
};

export const getTravelTimelineApi = async (travelId) => {
  const { data } = await api.get(`/api/v1/travels/${travelId}/timeline`);
  return data;
};

export const getTravelQRCodeApi = async (travelId) => {
  const { data } = await api.get(`/api/v1/travels/${travelId}/qrcode`);
  return data;
};

// ─── Rider ────────────────────────────────────────────────────────────────────

export const getAvailableTravelsApi = async () => {
  const { data } = await riderApi.get("/api/v1/travels/available");
  return data;
};

export const riderAcceptTravelApi = async (travelId) => {
  const { data } = await riderApi.post(`/api/v1/travels/${travelId}/rider-accept`);
  return data;
};

export const riderStartTravelApi = async (travelId) => {
  const { data } = await riderApi.post(`/api/v1/travels/${travelId}/start`);
  return data;
};

export const riderCompleteTravelApi = async (travelId) => {
  const { data } = await riderApi.post(`/api/v1/travels/${travelId}/complete`);
  return data;
};
